"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactI18next = require("react-i18next");

var _Fade = _interopRequireDefault(require("@material-ui/core/Fade"));

var _Button = _interopRequireDefault(require("../Button"));

var _Image = _interopRequireWildcard(require("../Image"));

var View = function View(_ref) {
  var onClick = _ref.onClick;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/_react["default"].createElement(_Fade["default"], {
    "in": true
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-screen h-screen p-8"
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
    width: "445",
    hegiht: "134",
    alt: "onmail",
    className: "w-32",
    src: (0, _Image.withThemeSrc)(t('onmail.png'), t('onmail-light.png'))
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-full w-full flex flex-col items-center justify-center"
  }, /*#__PURE__*/_react["default"].createElement("h1", {
    className: "text-primary text-5xl font-semibold"
  }, t('deleteAccount.success.title')), /*#__PURE__*/_react["default"].createElement("h3", {
    className: "text-2xl font-light"
  }, t('deleteAccount.success.subtitle')), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt-6"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    className: "w-64",
    onClick: onClick
  }, t('button.homepage'))))));
};

View.display = 'DeleteAccountSuccess';
var _default = View;
exports["default"] = _default;
//# sourceMappingURL=index.js.map